import type { ComponentProps } from "react";

export default function BoxIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.80176 2.05566C9.92404 1.98145 10.076 1.98145 10.1982 2.05566L16.8093 6.07894C16.9271 6.15159 17 6.28207 17 6.42347V13.5765C17 13.7179 16.9271 13.8484 16.8093 13.9211L10.1982 17.9443C10.076 18.0186 9.92404 18.0186 9.80176 17.9443L3.19065 13.9211C3.07292 13.8484 3 13.7179 3 13.5765V6.42347C3 6.28206 3.07292 6.1516 3.19065 6.07894L9.80176 2.05566ZM3.77787 7.12526V13.3485L9.6112 16.8985V10.6752L8.25009 9.84709V13.0002C8.25009 13.1455 8.17338 13.2799 8.04957 13.3502C7.92576 13.4205 7.77461 13.4166 7.65537 13.3393L5.32204 11.8393C5.20811 11.7659 5.13898 11.6377 5.13898 11.5002V7.95344L3.77787 7.12526ZM5.91676 8.42681V11.2784L7.47231 12.2784V9.37379L5.91676 8.42681ZM8.70736 9.19554L10.0001 9.98225L15.8479 6.42363L10.0001 2.86502L4.15236 6.42363L5.60614 7.30799C5.61905 7.31111 5.63272 7.31424 5.64563 7.31893L8.5328 5.60412C8.64902 5.53459 8.7918 5.53224 8.9103 5.59709L11.34 6.9252C11.4646 6.99395 11.5436 7.12598 11.5459 7.27206C11.5482 7.41737 11.4737 7.55252 11.3514 7.62519L8.70736 9.19554ZM6.40222 7.79321L8.73555 6.4073L10.3549 7.29322L7.93879 8.72835L6.40222 7.79321ZM16.2225 7.12526L10.3891 10.6752V16.8985L16.2225 13.3485V7.12526Z"
        fill="currentColor"
      />
    </svg>
  );
}
